import { languages } from "../supportedLanguages";

const keys = Object.keys(languages);

export const isLanguageSupported = (l:string) => keys.includes(l);